import React, { useState } from "react";
import { Row, Col, Card, Button, InputNumber } from "antd";
import styled from "styled-components";
import { addZeroes } from "../../config/utils";
import info from "../info";
import LoaderGif from "../../assets/images/ie_loader.gif";

const ShippingCostWrapper = styled(Card)`
  min-height: 200px;
  .ant-card-body {
    padding: 0;
  }
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  padding: 10px;

  .shiping-cost {
    align-items: center;
    padding: 10px 15px;
    font-size: 16px;
  }
  margin-top: 20px;
`;

export default function ShippingCost({
  onUpdateShippingCost,
  updateShippingCost,
  value,
  shipingprice,
  postShippingCost,
  onPostShippingCost,
  isShippingCostLoading,
}) {
  const [shiippingValue, setShippingValue] = useState(value);
  console.log("val===>", shiippingValue);
  return (
    <Row justify="center">
      <Col xl={24} xs={24} sm={24} lg={24} md={24}>
        <ShippingCostWrapper>
          <Row justify="start">
            <Col xl={14}>
              <h5
                className="text-left"
                style={{ padding: "5px 5px 10px 5px", fontSize: "16.5px" }}
              >
                Expedite Order Cost
              </h5>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xl={10}>
              <p className="text-left shiping-cost">Yes</p>
            </Col>
            <Col xl={14}>
              <span className="shiping-cost">$</span>
              <InputNumber
                onChange={(e) => {
                  onUpdateShippingCost(e, "am_charges");
                  // setShippingValue({ ...shiippingValue, am_charges: e })
                }}
                name="am_charges"
                value={value.am_charges}
                type="number"
              />
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xl={10}>
              <p className="text-left shiping-cost">No</p>
            </Col>
            <Col xl={14}>
              <span className="shiping-cost">$</span>
              <InputNumber
                onChange={(e) => {
                  onUpdateShippingCost(e, "pm_charges");
                  // setShippingValue({ ...shiippingValue, pm_charges: e })
                }}
                name="pm_charges"
                value={value.pm_charges}
                type="number"
              />
            </Col>
          </Row>
          <Row justify="end">
            <Col>
              {!isShippingCostLoading && (
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "100%",
                  }}
                  onClick={
                    // onPostShippingCost
                    //   ? () => postShippingCost(value)
                    //   : () => updateShippingCost(value, shipingprice.id)
                    () => {
                      // if (value.am_charges <= 0 || value.pm_charges <= 0) {
                      //   info('error', 'Shipping charges is not valid!')
                      //   return
                      // }
                      if (
                        value?.pm_charges == null ||
                        value?.am_charges == null
                      ) {
                        info("error", "Shipping charges can not be left empty");
                        return;
                      }
                      if (shipingprice.id) {
                        updateShippingCost(value, shipingprice.id);
                        return;
                      }
                      if (!shipingprice.id || onPostShippingCost) {
                        postShippingCost(value);
                      }
                    }
                  }
                  //   onClick={() => updateShippingCost(value, shipingprice.id)}
                >
                  SAVE
                </Button>
              )}
              {isShippingCostLoading && (
                <img src={LoaderGif} height={"40"} width={"40"} />
              )}
            </Col>
          </Row>
        </ShippingCostWrapper>
      </Col>
    </Row>
  );
}
